import React, { useState } from "react";
import { Link } from "react-router-dom";
import navbell from "../imgs/navbell.svg";
import navprofile from "../imgs/navprofile.svg";
function Navbar({ page }) {
  const [notificationDropdown, setNotificationDropdown] = useState(false);
  return (
    <div className="p-8  ">
      <div className="w-full flex justify-between">
        {page === "airtimetocash" ? (
          <p className="text-[#2B3B5A] text-[20px] leading-7 font-medium tracking-[2%]">
            Airtime to Cash
          </p>
        ) : page === "transaction" ? (
          <p className="text-[#2B3B5A] text-[20px] leading-7 font-medium tracking-[2%]">
            Transaction History
          </p>
        ) : page === "support" ? (
          <p className="text-[#2B3B5A] text-[20px] leading-7 font-medium tracking-[2%]">
            Help And Support
          </p>
        ) : (
          <p className="text-[#2B3B5A] text-[20px] leading-7 font-medium tracking-[2%]">
            Welcome, Lawal Wahab
          </p>
        )}
        <div className="flex items-center gap-5 pr-4">
          <p className="text-[#4169E1] text-[16px] leading-4 tracking-[2%]  hover:text-[#000080] active:opacity-85 font-semibold">
            Upgrade To Merchant
          </p>
          <div onClick={() => setNotificationDropdown(!notificationDropdown)}>
            <img
              src={navbell}
              alt=""
              className="hover:scale-105 hover:duration-100 "
              onClick={() => setNotificationDropdown(!notificationDropdown)}
            />
            {notificationDropdown ? (
              <div className="absolute top-18 right-5 border-2 border-gray-300   bg-white shadow-md rounded-lg px-6 py-8">
                <p className="text-gray-600 font-medium text-[16px] text-center">
                  You have no notification
                </p>
              </div>
            ) : (
              <div></div>
            )}
          </div>

          <Link to="/profile">
            <img
              src={navprofile}
              alt=""
              className="hover:scale-105 hover:duration-100"
            />
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Navbar;
